export var OrgContractStatus;
(function (OrgContractStatus) {
    OrgContractStatus["DRAFT"] = "Draft";
    OrgContractStatus["READY"] = "Ready";
    OrgContractStatus["ACTIVE"] = "Active";
    OrgContractStatus["EXPIRED"] = "Expired";
    OrgContractStatus["TERMINATED"] = "Terminated";
})(OrgContractStatus || (OrgContractStatus = {}));
export var ServiceOrgContractStatus;
(function (ServiceOrgContractStatus) {
    ServiceOrgContractStatus["DRAFT"] = "DRAFT";
    ServiceOrgContractStatus["READY"] = "READY";
    ServiceOrgContractStatus["ACTIVE"] = "ACTIVE";
    ServiceOrgContractStatus["EXPIRED"] = "EXPIRED";
    ServiceOrgContractStatus["TERMINATED"] = "TERMINATED";
})(ServiceOrgContractStatus || (ServiceOrgContractStatus = {}));
export var OrgContractMediaTypeQualifier;
(function (OrgContractMediaTypeQualifier) {
    OrgContractMediaTypeQualifier["VIDEO"] = "Video";
    OrgContractMediaTypeQualifier["AUDIO"] = "Audio";
    OrgContractMediaTypeQualifier["DISPLAY"] = "Display";
})(OrgContractMediaTypeQualifier || (OrgContractMediaTypeQualifier = {}));
export var ServiceOrgContractMediaTypeQualifier;
(function (ServiceOrgContractMediaTypeQualifier) {
    ServiceOrgContractMediaTypeQualifier["VIDEO"] = "VIDEO";
    ServiceOrgContractMediaTypeQualifier["AUDIO"] = "AUDIO";
    ServiceOrgContractMediaTypeQualifier["DISPLAY"] = "DISPLAY";
})(ServiceOrgContractMediaTypeQualifier || (ServiceOrgContractMediaTypeQualifier = {}));
export var OrgContractVideoTypeQualifier;
(function (OrgContractVideoTypeQualifier) {
    OrgContractVideoTypeQualifier["OTT"] = "OTT";
    OrgContractVideoTypeQualifier["OLV"] = "OLV";
    OrgContractVideoTypeQualifier["OTV"] = "OTV";
    OrgContractVideoTypeQualifier["DOOH"] = "DOOH";
})(OrgContractVideoTypeQualifier || (OrgContractVideoTypeQualifier = {}));
export var ServiceOrgContractVideoTypeQualifier;
(function (ServiceOrgContractVideoTypeQualifier) {
    ServiceOrgContractVideoTypeQualifier["OTT"] = "OTT";
    ServiceOrgContractVideoTypeQualifier["OLV"] = "OLV";
    ServiceOrgContractVideoTypeQualifier["OTV"] = "OTV";
    ServiceOrgContractVideoTypeQualifier["DOOH"] = "DOOH";
})(ServiceOrgContractVideoTypeQualifier || (ServiceOrgContractVideoTypeQualifier = {}));
export var OrgContractDisplayTypeQualifier;
(function (OrgContractDisplayTypeQualifier) {
    OrgContractDisplayTypeQualifier["DT_DOOH"] = "DT_DOOH";
    OrgContractDisplayTypeQualifier["TRADITIONAL"] = "Traditional";
})(OrgContractDisplayTypeQualifier || (OrgContractDisplayTypeQualifier = {}));
export var ServiceOrgContractDisplayTypeQualifier;
(function (ServiceOrgContractDisplayTypeQualifier) {
    ServiceOrgContractDisplayTypeQualifier["DT_DOOH"] = "DT_DOOH";
    ServiceOrgContractDisplayTypeQualifier["TRADITIONAL"] = "TRADITIONAL";
})(ServiceOrgContractDisplayTypeQualifier || (ServiceOrgContractDisplayTypeQualifier = {}));
export var OrgContractMadSupplyChargeType;
(function (OrgContractMadSupplyChargeType) {
    OrgContractMadSupplyChargeType["RATE_CARD"] = "Rate Card";
    OrgContractMadSupplyChargeType["COST_PLUS"] = "Cost Plus";
})(OrgContractMadSupplyChargeType || (OrgContractMadSupplyChargeType = {}));
export var ServiceOrgContractMadSupplyChargeType;
(function (ServiceOrgContractMadSupplyChargeType) {
    ServiceOrgContractMadSupplyChargeType["RATE_CARD"] = "RATE_CARD";
    ServiceOrgContractMadSupplyChargeType["COST_PLUS"] = "COST_PLUS";
})(ServiceOrgContractMadSupplyChargeType || (ServiceOrgContractMadSupplyChargeType = {}));
export var OrgContractFeeType;
(function (OrgContractFeeType) {
    OrgContractFeeType["CPM"] = "CPM";
    OrgContractFeeType["PCT"] = "PCT";
})(OrgContractFeeType || (OrgContractFeeType = {}));
export var OrgContractDataTypeQualifierType;
(function (OrgContractDataTypeQualifierType) {
    OrgContractDataTypeQualifierType["RETARGETING"] = "Retargeting";
    OrgContractDataTypeQualifierType["FIRST_PARTY"] = "First Party";
    OrgContractDataTypeQualifierType["THIRD_PARTY"] = "Third Party";
})(OrgContractDataTypeQualifierType || (OrgContractDataTypeQualifierType = {}));
export var ServiceOrgContractDataTypeQualifierType;
(function (ServiceOrgContractDataTypeQualifierType) {
    ServiceOrgContractDataTypeQualifierType["RETARGETING"] = "RETARGETING";
    ServiceOrgContractDataTypeQualifierType["FIRST_PARTY"] = "FIRST_PARTY";
    ServiceOrgContractDataTypeQualifierType["THIRD_PARTY"] = "THIRD_PARTY";
})(ServiceOrgContractDataTypeQualifierType || (ServiceOrgContractDataTypeQualifierType = {}));
//# sourceMappingURL=types.js.map